export const extendMainContainer = {
    container: ({ theme: { colors } }) => ({
        backgroundColor: colors.black,
        color: colors.white,
        position: 'relative',
    }),
};

export const mapContainer = () => ({
    position: 'relative',
    width: '100%',
    height: '31.25rem',
    gridColumn: ' auto / span 12',
    marginTop: '3rem',

    tabletLarge: {
        marginTop: '0',
        position: 'absolute',
        height: '100%',
        width: '50%',
        right: 0,
        top: 0,
    },
});

export const extendTitle = {
    title: ({ theme: { colors } }) => ({
        color: colors.white,
        marginTop: 0,
    }),
};

export const extendText = {
    text: ({ theme: { colors } }) => ({
        color: colors.white,
        marginBottom: 0,
    }),
};

export const extendSubtitle = {
    title: ({ theme: { colors } }) => ({
        color: colors.white,
        lineHeight: '3rem',
        margin: 0,

        tabletLarge: {
            fontSize: '2rem',
        },
    }),
};

export const addressContainer = {
    marginTop: '2rem',
};

export const driveryImage = {
    width: '6.1875rem',
    height: '4rem',
    marginTop: '10.75rem',
};
